import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi)

import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})

import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyAb_81Un9coKiBV483K1isioubDGZDJIaQ",
  authDomain: "diss-study1.firebaseapp.com",
  databaseURL: "https://diss-study1-default-rtdb.firebaseio.com",
  projectId: "diss-study1",
  storageBucket: "diss-study1.appspot.com",
  messagingSenderId: "241912697689",
  appId: "1:241912697689:web:5d5e746efc502015beb248",
  measurementId: "G-BD7KP9JJXX"
};
initializeApp(firebaseConfig);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
